import { Check } from 'lucide-react';

interface IconProps {
  className?: string;
  size?: number;
  strokeWidth?: number;
}

export function CheckIcon({ className = '', size = 24, strokeWidth = 1.5 }: IconProps) {
  return (
    <Check
      width={size}
      height={size}
      strokeWidth={strokeWidth}
      className={className}
    />
  );
}
